(function (window, $j) {

    var jsonArray = [
        {
            "Display Name": "Omni San Francisco Hotel",
            "City": "San Francisco",
            "State": "California",
            "Latitude": 37.7931861111,
            "Longitude": -122.4031861111,
            "Region": "west",
            "VenueTypes": ["resort"],
            "Attendees": 0,
            "Amenities": ["ski","golf"]
        },
        {
            "Display Name": "Omni William Penn Hotel",
            "City": "Pittsburgh",
            "State": "Pennsylvania",
            "Latitude": 40.4402777778,
            "Longitude": -79.9966666667,
            "Region": "east",
            "VenueTypes": ["resort"],
            "Attendees": 50,
            "Amenities": ["ski"]
        },
        {
            "Display Name": "Omni Severin Hotel",
            "City": "Indianapolis",
            "State": "Indiana",
            "Latitude": 39.7638416667,
            "Longitude": -86.1595916667,
            "Region": "central",
            "VenueTypes": ["resort"],
            "Attendees": 200,
            "Amenities": ["golf","beach"]
        },
        {
            "Display Name": "Omni Shoreham Hotel",
            "City": "Washington",
            "State": "District of Columbia",
            "Latitude": 38.923025,
            "Longitude": -77.0537055556,
            "Region": "east",
            "VenueTypes": ["resort"],
            "Attendees": 500,
            "Amenities": ["spa"]
        },
        {
            "Display Name": "Omni Royal Orleans",
            "City": "New Orleans",
            "State": "Louisiana",
            "Latitude": 29.9561111111,
            "Longitude": -90.0652777778,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 0,
            "Amenities": ["spa"]
        },
        {
            "Display Name": "Omni Dallas Hotel",
            "City": "Dallas",
            "State": "Texas",
            "Latitude": 32.7755111111,
            "Longitude": -96.8039638889,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 50,
            "Amenities": ["spa"]
        },
        {
            "Display Name": "Omni Providence Hotel",
            "City": "Providence",
            "State": "Rhode Island",
            "Latitude": 41.825,
            "Longitude": -71.4163888889,
            "Region": "east",
            "VenueTypes": ["resort"],
            "Attendees": 200,
            "Amenities": ["spa"]
        },
        {
            "Display Name": "Omni Austin Hotel at Southpark",
            "City": "Austin",
            "State": "Texas",
            "Latitude": 30.2144444444,
            "Longitude": -97.7505555556,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": ["spa"]
        },
        {
            "Display Name": "Omni Nashville Hotel",
            "City": "Nashville",
            "State": "Tennessee",
            "Latitude": 36.15725,
            "Longitude": -86.7754722222,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Bedford Springs Resort",
            "City": "Bedford",
            "State": "Pennsylvania",
            "Latitude": 39.9961111111,
            "Longitude": -78.5066666667,
            "Region": "east",
            "VenueTypes": ["city-center"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni La Mansión del Rio",
            "City": "San Antonio",
            "State": "Texas",
            "Latitude": 29.4255555556,
            "Longitude": -98.4908333333,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Scottsdale Resort & Spa at Montelucia",
            "City": "Scottsdale",
            "State": "Arizona",
            "Latitude": 33.5286972222,
            "Longitude": -111.9730666667,
            "Region": "west",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Parker House",
            "City": "Boston",
            "State": "Massachusetts",
            "Latitude": 42.3578333333,
            "Longitude": -71.0602222222,
            "Region": "east",
            "VenueTypes": ["city-center"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Cancun Hotel & Villas",
            "City": "Cancun",
            "State": "Quintana Roo",
            "Latitude": 21.0749722222,
            "Longitude": -86.7757111111,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni Los Angeles Hotel at California Plaza",
            "City": "Los Angeles",
            "State": "California",
            "Latitude": 34.0527777778,
            "Longitude": -118.2505555556,
            "Region": "west",
            "VenueTypes": ["city-center"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Orlando Resort at ChampionsGate",
            "City": "ChampionsGate",
            "State": "Florida",
            "Latitude": 28.2616555556,
            "Longitude": -81.6266722222,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni San Antonio Hotel at the Colonnade",
            "City": "San Antonio",
            "State": "Texas",
            "Latitude": 29.53565,
            "Longitude": -98.5642638889,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Majestic Hotel",
            "City": "St. Louis",
            "State": "Missouri",
            "Latitude": 38.6288222222,
            "Longitude": -90.1956333333,
            "Region": "central",
            "VenueTypes": ["suburban"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni Houston Hotel at Westside",
            "City": "Houston",
            "State": "Texas",
            "Latitude": 29.785,
            "Longitude": -95.6177777778,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Charlotte Hotel",
            "City": "Charlotte",
            "State": "North Carolina",
            "Latitude": 35.226333333,
            "Longitude": -80.8424722222,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Hilton Head Oceanfront Resort",
            "City": "Hilton Head",
            "State": "South Carolina",
            "Latitude": 32.1626388889,
            "Longitude": -80.7221388889,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Royal Crescent Hotel",
            "City": "New Orleans",
            "State": "Louisiana",
            "Latitude": 29.9508333333,
            "Longitude": -90.0683333333,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni Barton Creek Resort & Spa",
            "City": "Austin",
            "State": "Texas",
            "Latitude": 30.2919444444,
            "Longitude": -97.86,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Richmond Hotel",
            "City": "Richmond",
            "State": "Virginia",
            "Latitude": 37.5358333333,
            "Longitude": -77.4347222222,
            "Region": "east",
            "VenueTypes": ["suburban"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Austin Hotel Downtown",
            "City": "Austin",
            "State": "Texas",
            "Latitude": 30.2688888889,
            "Longitude": -97.7402777778,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Amelia Island Plantation Resort",
            "City": "Amelia Island",
            "State": "Florida",
            "Latitude": 30.555673,
            "Longitude": -81.443847,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni Houston Hotel",
            "City": "Houston",
            "State": "Texas",
            "Latitude": 29.7615444444,
            "Longitude": -95.4593055556,
            "Region": "south",
            "VenueTypes": ["suburban"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Berkshire Place",
            "City": "New York",
            "State": "New York",
            "Latitude": 40.7594444444,
            "Longitude": -73.9752777778,
            "Region": "east",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni La Costa Resort & Spa (Carlsbad)",
            "City": "Carlsbad",
            "State": "California",
            "Latitude": 33.0919138889,
            "Longitude": -117.266,
            "Region": "west",
            "VenueTypes": ["convention"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Rancho Las Palmas Resort & Spa",
            "City": "Rancho Mirage",
            "State": "California",
            "Latitude": 33.742072,
            "Longitude": -116.405985,
            "Region": "west",
            "VenueTypes": ["convention"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Hotel Omni Mont-Royal",
            "City": "Montreal",
            "State": "Quebec",
            "Latitude": 45.5019166667,
            "Longitude": -73.575936111,
            "Region": "east",
            "VenueTypes": ["convention"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Tucson National Resort",
            "City": "Tucson",
            "State": "Arizona",
            "Latitude": 32.3580555556,
            "Longitude": -111.0269444444,
            "Region": "west",
            "VenueTypes": ["convention"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Chicago Hotel",
            "City": "Chicago",
            "State": "Illinois",
            "Latitude": 41.8946944444,
            "Longitude": -87.6248611111,
            "Region": "central",
            "VenueTypes": ["convention"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Mandalay Hotel at Las Colinas",
            "City": "Dallas (Irving)",
            "State": "Texas",
            "Latitude": 32.8672222222,
            "Longitude": -96.9388888889,
            "Region": "south",
            "VenueTypes": ["convention"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni Atlanta Hotel at CNN Center",
            "City": "Atlanta",
            "State": "Georgia",
            "Latitude": 33.7595833333,
            "Longitude": -84.3950277778,
            "Region": "south",
            "VenueTypes": ["convention"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Bretton Arms Inn at Mount Washington",
            "City": "Bretton Woods",
            "State": "New Hampshire",
            "Latitude": 44.2572027778,
            "Longitude": -71.4398333333,
            "Region": "east",
            "VenueTypes": ["convention"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Mount Washington Resort",
            "City": "Bretton Woods",
            "State": "New Hampshire",
            "Latitude": 44.2574444444,
            "Longitude": -71.4394638889,
            "Region": "east",
            "VenueTypes": ["convention"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Corpus Christi Hotel",
            "City": "Corpus Christi",
            "State": "Texas",
            "Latitude": 27.8003888889,
            "Longitude": -97.3922222222,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "The Omni King Edward Hotel",
            "City": "Toronto",
            "State": "Ontario",
            "Latitude": 43.6494444444,
            "Longitude": -79.3761111111,
            "Region": "east",
            "VenueTypes": ["city-center"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Charlottesville Hotel",
            "City": "Charlottesville",
            "State": "Virginia",
            "Latitude": 38.0313888889,
            "Longitude": -78.4841944444,
            "Region": "east",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Puerto Aventuras Beach Resort",
            "City": "Puerto Aventuras",
            "State": "Quintana Roo",
            "Latitude": 20.4997666667,
            "Longitude": -87.2275,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "The Omni Grove Park Inn",
            "City": "Asheville",
            "State": "North Carolina",
            "Latitude": 35.6205555556,
            "Longitude": -82.5422222222,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni San Diego Hotel",
            "City": "San Diego",
            "State": "California",
            "Latitude": 32.7071111111,
            "Longitude": -117.1588611111,
            "Region": "west",
            "VenueTypes": ["city-center"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Mokara Hotel & Spa",
            "City": "San Antonio",
            "State": "Texas",
            "Latitude": 29.4255555556,
            "Longitude": -98.4908333333,
            "Region": "south",
            "VenueTypes": ["city-center"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Interlocken Hotel",
            "City": "Broomfield",
            "State": "Colorado",
            "Latitude": 39.9275,
            "Longitude": -105.1183333333,
            "Region": "west",
            "VenueTypes": ["resort"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Dallas Hotel at Park West",
            "City": "Dallas",
            "State": "Texas",
            "Latitude": 32.905,
            "Longitude": -96.9208333333,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "Omni New Haven Hotel at Yale",
            "City": "New Haven",
            "State": "Connecticut",
            "Latitude": 41.3056638889,
            "Longitude": -72.9274722222,
            "Region": "east",
            "VenueTypes": ["resort"],
            "Attendees": 200,
            "Amenities": []
        },
        {
            "Display Name": "Omni Fort Worth Hotel",
            "City": "Fort Worth",
            "State": "Texas",
            "Latitude": 32.7483333333,
            "Longitude": -97.3280555556,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 500,
            "Amenities": []
        },
        {
            "Display Name": "Omni Riverfront Hotel",
            "City": "New Orleans",
            "State": "Louisiana",
            "Latitude": 29.9456948,
            "Longitude": -90.0649408,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 0,
            "Amenities": []
        },
        {
            "Display Name": "Omni Jacksonville Hotel",
            "City": "Jacksonville",
            "State": "Florida",
            "Latitude": 30.3261555556,
            "Longitude": -81.6620944444,
            "Region": "south",
            "VenueTypes": ["resort"],
            "Attendees": 50,
            "Amenities": []
        },
        {
            "Display Name": "The Omni Homestead Resort",
            "City": "Hot Springs",
            "State": "Virginia",
            "Latitude": 37.9972222222,
            "Longitude": -79.8294444444,
            "Region": "east",
            "VenueTypes": ["resort"],
            "Attendees": 200,
            "Amenities": []
        }
    ];
    var markers = [];

    function onDocReady() {
        if($j(".finder-container").length) {
            $j(".finder-container .tabs-container .tab").click(toggleTabSections);
            $j(".finder-container .filter-button input").click(filterClick);
            $j(".finder-container .filter-item .clear-button").click(clearFilters);
            $j(".finder-container .filter-item .filter-title").click(toggleFilter);
            $j("[name='event-type']").click(filtersChange);
            $j(window).resize(resizeFunction);
            initMap();
            updateSelections();
            adjustSectionHeight();
        }
    }

    function filtersChange() {
        $j(".filter-item").addClass("hidden");

        if ($j(this).val() === "Meeting") {
            $j(".filter-item.venue-filter").removeClass("hidden");
            $j(".finder-container").addClass("venue-matcher");
            $j(".finder-container").removeClass("destination-finder");
            $j(".weddings-shown").addClass("hidden");
            $j(".meetings-shown").removeClass("hidden");
        }
        else {
            if ($j(this).val() === "Wedding") {
                $j(".filter-item.destination-filter").removeClass("hidden");
                $j(".finder-container").addClass("destination-finder");
                $j(".finder-container").removeClass("venue-matcher");
                $j(".meetings-shown").addClass("hidden");
                $j(".weddings-shown").removeClass("hidden");
            }
        }

        updateSelections();
    }

    // the Marker class
    function Marker(id, map, place) {
        this.id = "hotel-result-" + id;
        this.name = place["Details"]["DisplayName"];
        this.locationID = place["Details"]["LocationId"];
        this.meetingPhone = place["Details"]["MeetingsPhone"];
        this.weddingPhone = place["Details"]["WeddingsPhone"];
        this.url = place["Details"]["Url"];
        this.mapURL = place["Details"]["MapUrl"];
        this.city = place["Location"]["City"];
        this.state = place["Location"]["State"];
        this.lat = parseFloat(place["Location"]["Latitude"]);
        this.long = parseFloat(place["Location"]["Longitude"]);
        this.imageURL = place["Image"]["Url"];
        this.imageAlt = place["Image"]["Alt"];
        this.region = place["Filters"]["Region"];
        this.propertyTypes = place["Filters"]["PropertyType"]; // array
        this.destinationType = place["Filters"]["DestinationType"];
        this.meetingAttendees = place["Filters"]["MeetingAttendees"];
        this.weddingAttendees = place["Filters"]["WeddingAttendees"];
        this.amenities = place["Filters"]["Amenities"]; // array
        this.meetingStats = place["MeetingStats"]; // object
        this.weddingStats = place["WeddingStats"]; // array
        this.hidden = false;
        this.addedRFP = false;

        var self = this;
        var map = map;

        var addToButtonClass = "";
        var goToButtonClass = "hide-button";

        if(AddToRFP.isSaved(this.locationID.toString())) {
            addToButtonClass = "rfp-added";
            goToButtonClass = "";
        }

        // string for the map view info windows
        var contentString =
            '<div class="hotel-item" data-list-link="' + this.id + '" xmlns="http://www.w3.org/1999/html" data-location-id="' + this.locationID + '">' +
            //'<div class="image-container" style="background-image: url(\'dev-images/hotel1.png\');"></div>' +
            '<div class="details-container">' +
            '<div class="info-container">' +
            '<div class="info-left">' +
            '<a href="/" class="hotel-name">' + this.name + '</a>' +
            '<div class="links">' +
            '<span class="location">' + this.city + ', ' + this.state + '</span>' +
            '<span><a href="' + this.meetingPhone + '" class="phone meeting-phone meetings-shown"></a>' + this.meetingPhone + '</span>' +
            '<span><a href="' + this.weddingPhone + '" class="phone wedding-phone weddings-shown hidden">' + this.weddingPhone + '</a></span>' +
            '</div>' +
            '</div>' +
            '<div class="info-right button-container">' +
            '<button class="btn btn-brand add-button add-to-myrfp-button ' + addToButtonClass + '"><span class="fa fa-check added-indicator"></span><span class="button-text">Add to My RFP</span></button>' +
            '<a href="/meetings/rfp" class="btn btn-explore go-to-rfp ' + goToButtonClass + '">Go to My RFP</a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';

        // string for the list view content
        var listString =
            '<div class="hotel-item show-result" id="' + this.id + '" data-location-id="' + this.locationID + '">' +
            '<div class="image-container" style="background-image: url(\'' + this.imageURL + '\');"></div>' +
            '<div class="details-container">' +
                '<div class="info-container">' +
                    '<div class="info-left">' +
                        '<a href="/" class="hotel-name">' + this.name + '</a>' +
                        '<div class="links">' +
                            '<span class="location">' + this.city + ', ' + this.state + '</span>' +
                            '<span class="meetings-shown"><a href="' + this.meetingPhone + '" class="phone meeting-phone"></a>' + this.meetingPhone + '</span>' +
                            '<span class="weddings-shown hidden"><a href="' + this.weddingPhone + '" class="phone wedding-phone">' + this.weddingPhone + '</a></span>' +
                            '<span><a href="' + this.mapURL + '" class="map">Map<img src="/images/meetings-weddings/map.png"/></a></span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="info-right button-container">' +
                        '<button class="btn btn-brand add-button add-to-myrfp-button ' + addToButtonClass + '"><span class="fa fa-check added-indicator"></span><span class="button-text">Add to My RFP</span></button>' +
                        '<a href="/meetings/rfp" class="btn btn-explore go-to-rfp ' + goToButtonClass + '">Go to My RFP</a>' +
                    '</div>' +
                '</div>' +
                '<div class="stats-container">' +


                '<div class="stats-table meeting-stats-table meetings-shown">' +
                    '<div class="stat-row">' +
                        '<div class="stat-item">' +
                            '<span class="small-text">Guest Rooms</span>' +
                            '<span class="large-text">' + this.meetingStats["Rooms"] + '</span>' +
                        '</div>' +
                        '<div class="stat-item">' +
                            '<span class="small-text">Largest Meeting Room</span>' +
                            '<span class="large-text">' + this.meetingStats["MeetingRoom"] + ' sq ft</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="stat-row">' +
                        '<div class="stat-item">' +
                            '<span class="small-text">Total Sq. Ft.</span>' +
                            '<span class="large-text">' + this.meetingStats["SqFt"] + ' sq ft</span>' +
                        '</div>';

        if(this.meetingStats["FloorPlanURL"] !== 'undefined') {
            listString +=
            '<div class="stat-item">' +
            '<a href="' + this.meetingStats["FloorPlanURL"] + '" class="floor-link">View Floorplans</a>' +
            '</div>';
        }
                listString +=
                    '</div>' +
                '</div>' +

                '<div class="stats-table wedding-stats-table weddings-shown hidden">' +
                    '<div class="stat-row">';

            for(var i = 0;i < this.weddingStats.length; i++) {
                listString +=
                    '<div class="stat-item">' +
                        '<span class="small-text">' + this.weddingStats[i]["key"] + '</span>' +
                        '<span class="large-text">' + this.weddingStats[i]["value"] + '</span>' +
                    '</div>';

                if(i === 1) {
                    listString += '</div><div class="stat-row">';
                }
            }

        listString += '</div></div></div></div></div>';

        // add result to the list section
        $j(".list-section").append(listString);

        // setup the image to use as a marker
        var image = {
            url: '/images/meetings-weddings/dot.png',
            anchor: new google.maps.Point(16, 16)
        };

        // create a new marker for this location
        var marker = new google.maps.Marker({
            position: {lat: this.lat, lng: this.long},
            map: map,
            title: this.name,
            icon: image
        });

        // define the info window for marker click
        var infowindow = new google.maps.InfoWindow({
            content: contentString
        });

        // add listener for when marker is clicked
        marker.addListener('click', function () {

            // close other open marker info window
            for (var i = 0; i < markers.length; i++) {
                markers[i].closeWindow();
            }

            // open this info window
            infowindow.open(map, marker);

            // register event for clicking the add button in the window
            $j("#map .hotel-item .add-button").click(function () {
                // animate adding item to RFP
                $j(this).addClass("rfp-added");
                $j(this).attr("disabled", "disabled");
                $j(this).closest(".hotel-item").find(".go-to-rfp").removeClass("hide-button");

                // handle the linked item in the list view to indicate the location is already added
                var linkedItem = $j(".list-section #" + self.id);
                linkedItem.find(".add-button").addClass("rfp-added");
                linkedItem.find(".add-button").attr("disabled", "disabled");
                linkedItem.find(".go-to-rfp").removeClass("hide-button");
            });

            // if location was added via the list view, indicate that
            if (self.addedRFP) {
                $j("#map .hotel-item .add-button").addClass("rfp-added");
                $j("#map .hotel-item .add-button").attr("disabled", "disabled");
                $j("#map .hotel-item .add-button").closest(".hotel-item").find(".go-to-rfp").removeClass("hide-button");
            }
        });

        // register the list view add button
        $j(".list-section .hotel-item#" + self.id + " .add-button").click(function () {
            $j(this).addClass("rfp-added");
            $j(this).attr("disabled", "disabled");
            $j(this).closest(".hotel-item").find(".go-to-rfp").removeClass("hide-button");

            var target = $j(this);

            for (var i = 0; i < markers.length; i++) {
                if (target.closest(".hotel-item").attr("id") === markers[i].id) {
                    markers[i].addedRFP = true;
                }
            }
        });

        // function hides marker
        this.hide = function () {
            marker.setMap(null);
            this.hidden = true;
            $j(".list-section #" + this.id).removeClass("show-result");
        };

        // function shows marker
        this.show = function () {
            marker.setMap(map);
            this.hidden = false;
            $j(".list-section #" + this.id).addClass("show-result");
        };

        // function closes the info window
        this.closeWindow = function () {
            infowindow.close();
        }
    }

    // initialize the map
    function initMap() {

        var myLatLng = {lat: 37.024262, lng: -96.119023};
        var styles = [
            {
                "featureType": "all",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "color": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "hue": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "hue": "#00ff81"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": "1"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#cfcfcf"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.terrain",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.terrain",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape.natural.terrain",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            }
        ];
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: 4,
            center: myLatLng,
            disableDefaultUI: true,
            zoomControl: true,
            styles: styles
        });
        map.addListener('click', function () {
            for (var i = 0; i < markers.length; i++) {
                markers[i].closeWindow();
            }
        });

        // request JSON data
        $j.getJSON( "/find/VenueFinder/GetAllHotelDetails", function( data ) {
            for (var i = 0; i < data.length; i++) {
                markers.push(new Marker(i, map, data[i]));
            }
            $j(".add-to-myrfp-button").click(AddToRFP.addtoRFP);
        });

    }

    // function for when a filter is clicked
    function filterClick() {
        $j(this).closest(".filter-item").find(".clear-button").removeClass("clear-hidden");
        updateSelections();
    }

    function toggleFilter() {
        if ($j(this).closest(".filter-item").find(".filter-content").hasClass("filter-open")) {
            $j(this).closest(".filter-item").find(".filter-content").removeClass("filter-open");
        }
        else {
            $j(this).closest(".filter-item").find(".filter-content").addClass("filter-open");
        }
    }

    function clearFilters() {

        $j(this).closest(".filter-item").find("input").prop("checked", false);
        $j(this).addClass("clear-hidden");

        updateSelections();
    }

    // function for when window is resized
    function resizeFunction() {
        adjustSectionHeight();
    }

    // function to toggle which tab is active
    function toggleTabSections() {
        if (!$j(this).hasClass("active")) {
            $j(".finder-container .tabs-container .tab").removeClass("active");
            $j(this).addClass("active");
            $j(".finder-container .tab-section").removeClass("active");
            $j(".finder-container .tab-section").eq($j(this).index()).addClass("active");

            adjustSectionHeight();
        }
    }

    // adjust the height of the currently opened tab
    function adjustSectionHeight() {
        $j(".finder-container .tab-section-container").css({
            "height": $j(".finder-container .tab-section.active").outerHeight() + 30 + "px"
        });
    }

    // update the visible results based on the filters
    function updateSelections() {

        // get the selected filter values
        var selected_region = $j("input[name='region-buttons']:checked").attr('id');
        var selected_venue_type = $j("input[name='venue-type-buttons']:checked").attr('id');
        var selected_location_type = $j("input[name='location-buttons']:checked").attr('id');
        var selected_attendees = $j("input[name='attendees-buttons']:checked").attr('id');
        var selected_amenities = [];
        var selected_features = [];

        // sanitize the amenities (convert to correct Values)
        $j("input[name='amenities-buttons']:checked").each(function () {
            switch($j(this).attr("id")) {
                case "venue-beach":
                    selected_amenities.push("Beach");
                    break;
                case "venue-golf":
                    selected_amenities.push("Golf");
                    break;
                case "venue-spa":
                    selected_amenities.push("Spa");
                    break;
                case "venue-ski":
                    selected_amenities.push("Ski");
                    break;
                case "venue-tennis":
                    selected_amenities.push("Tennis");
                    break;
            }
        });

        // sanitize destination features
        $j("input[name='-destination-features-buttons']:checked").each(function () {
            switch($j(this).attr("id")) {
                case "destination-beach":
                    selected_features.push("Beach");
                    break;
                case "destination-golf":
                    selected_features.push("Golf");
                    break;
                case "destination-spa":
                    selected_features.push("Spa");
                    break;
                case "destination-city":
                    selected_features.push("City");
                    break;
            }
        });

        // sanitize the selected region
        var region;
        switch(selected_region) {
            case "east-region":
                region = "East";
                break;
            case "south-region":
                region = "South";
                break;
            case "central-region":
                region = "Central";
                break;
            case "west-region":
                region = "West";
                break;
        }

        // sanitize the selected  venue type
        var venue_type;
        switch(selected_venue_type) {
            case "city-center-type":
                venue_type = "City";
                break;
            case "resort-type":
                venue_type = "Resort";
                break;
            case "suburban-type":
                venue_type = "Suburban";
                break;
            case "convention-type":
                venue_type = "Convention";
                break;
        }

        // sanitize the location type
        var location_type;
        switch(selected_location_type) {
            case "location-indoor":
                location_type = "Indoor";
                break;
            case "location-outdoor":
                location_type = "Outdoor";
                break;
            case "location-in-out":
                location_type = "Indoor/Outdoor";
                break;
        }

        // sanitize the selected attendees amount
        var attendees;
        switch(selected_attendees) {
            case "attendees-0":
                attendees = 0;
                break;
            case "attendees-50":
                attendees = 50;
                break;
            case "attendees-200":
                attendees = 200;
                break;
            case "attendees-500":
                attendees = 500;
                break;
        }

        //handle markers
        for (var i = 0; i < markers.length; i++) {
            if ($j(".finder-container").hasClass("venue-matcher")) {
                if (region !== undefined && markers[i].region !== region) {
                    markers[i].hide();
                }
                else {
                    if (venue_type !== undefined && markers[i].propertyTypes.indexOf(venue_type) === -1) {
                        markers[i].hide();
                    }
                    else {
                        if (attendees !== undefined && markers[i].meetingAttendees < attendees) {
                            markers[i].hide();
                        }
                        else {

                            // check the amenities
                            var meetsAmenities = true;

                            for(var j = 0;j < selected_amenities.length;j++) {
                                if(markers[i].amenities.indexOf(selected_amenities[j]) === -1) {
                                    meetsAmenities = false;
                                }
                            }

                            if(!meetsAmenities) {
                                markers[i].hide();
                            }
                            else {
                                markers[i].show();
                            }

                        }
                    }
                }
            }
            else if ($j(".finder-container").hasClass("destination-finder")) {
                if (region !== undefined && markers[i].region !== region) {
                    markers[i].hide();
                }
                else {
                    if (location_type !== undefined && markers[i].destinationType !== location_type) {
                        markers[i].hide();
                    }
                    else {
                        if (attendees !== undefined && markers[i].weddingAttendees < attendees) {
                            markers[i].hide();
                        }
                        else {
                            // check the features
                            var meetsFeatures = true;

                            for(var k = 0;k < selected_features.length;k++) {
                                if(markers[i].amenities.indexOf(selected_features[k]) === -1) {
                                    meetsFeatures = false;
                                }
                            }

                            if(!meetsFeatures) {
                                markers[i].hide();
                            }
                            else {
                                markers[i].show();
                            }
                        }
                    }
                }
            }
        }

        adjustSectionHeight();
    }

    $j(onDocReady);

    return {};

})(window, $j);